export default function Day17() {
  return (
    <div>
      <h1>Day 17</h1>
      <h1>Welcome to Day 17</h1>
    </div>
  );
}
